#import "../fragments/AutomationEditorFields.graphql"

mutation PauseAutomation($id: ID!) {
  pauseAutomation(id: $id) {
    ...AutomationEditorFields
  }
}
